import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import { InvalidatedDatasets } from "../types";

type State = InvalidatedDatasets;

const initialState: State = {
  tables: false,
  possibleTemplates: false,
  editRow: false,
};

const invalidatedDatasetsForTemplateIdReducer = reducer(
  initialState,
  on(AC.invalidateDatasetForAllTemplates, (state, action) => {
    const { dataset } = action.payload;
    state[dataset] = true;
  }),
  on(AC.revalidateDatasetForTemplate, (state, action) => {
    const { dataset } = action.payload;
    state[dataset] = false;
  })
);

export default invalidatedDatasetsForTemplateIdReducer;
export type InvalidatedDatasetsForTemplateIdReducer = State;
export const invalidatedDatasetsForTemplateIdInitialState = initialState;
